<template>
  <div class="class-list">
    <GlobalInfoBar
      title="订单识别中心"
      content="查看订单通过图片、功能、备注等信息识别的成色等级和故障项数据"
    >
    </GlobalInfoBar>
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From />
      </div>
      <Table />
    </GlobalChunk>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
export default {
  name: "class-list",
  components: {
    From,
    Table
  },
  data() {
    return {};
  },
  methods: {
  },
};
</script>

<style>
</style>